<template>
	<div v-parallax-fit="parallax" ref="slide27" class="finish-end">
		<img src="/themes/rise-theme/dist/images/estate/character-view/holly/32_WhiteHouseGroupShot_1.png" alt="">
	</div>
</template>

<script>
import { store } from '../../store';

export default {
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/holly/5.srt',
				'es': '/themes/rise-theme/resources/assets/audio/holly/5_es.srt'
			},
			mutationObserver: null,
			parallax: [
				{
					start: 25600,
					end: 25700,
					fromStyle: { transform: 'translateX(-45%) translateY(-50%) rotate(0deg)', opacity: '0' },
					toStyle: { transform: 'translateX(-45%) translateY(-50%) rotate(0deg)', opacity: '1' },
					easing: 'linear'
				},
			]
		}
	},
	created() {
		this.$watch('store.lang', newVal => {
			if (Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
		}, { immediate: true });
	},
	mounted() {
		const self = this;
		const audio = '/themes/rise-theme/resources/assets/audio/holly/5.mp3';

		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.opacity == '1') {
					self.$audioUrl.value = audio;
					self.$subtitlesUrl.value = this.subtitlesUrl[this.store.lang];
					self.$evidence.value = null;
					self.$readMore.value = '';
				}
			});
		});

		this.mutationObserver.observe(this.$refs.slide27, {
			attributes: true,
			attributeFilter: ['style']
		});
	},
	unmounted() {
		this.mutationObserver.disconnect();
	}

}
</script>

<style lang="scss" scoped>
.finish-end {
	position: absolute;
	top: 50%;
	left: 50%;
	max-width: 850px;
	width: 100%;
	transition: all 0.7s linear;
	z-index: 2;
}
</style>
